'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'bomb';
var width = 576;
var height = 512;
var aliases = [128163];
var unicode = 'f1e2';
var svgPathData = 'M480 152l24-64 64-24-64-24-24-64-24 64-64 24 64 24 24 64zM366.6 97.4L344 74.7c-17 17-28.2 28.2-33.5 33.5-22-7.9-45.8-12.2-70.5-12.2-114.9 0-208 93.1-208 208s93.1 208 208 208 208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5 5.3-5.3 16.5-16.5 33.5-33.5-5.5-5.5-39.7-39.7-102.6-102.6zM240 208c-53 0-96 43-96 96l0 24-48 0 0-24c0-79.5 64.5-144 144-144l24 0 0 48-24 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBomb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;